// extracted by mini-css-extract-plugin
export default {"children":"TextSelection_children__GlINI","overlay":"TextSelection_overlay__5v+Hg","canvas":"TextSelection_canvas__HBjQy","container":"TextSelection_container__aLlk9"};